export async function renewApp(params) {
    const { smartAccount, appRegistryDapp, fnArgs } = params;
    const { appAddress, signer, spaceAddress, installPrice } = fnArgs;
    if (!appRegistryDapp) {
        throw new Error('appRegistryDapp is required for renewApp operation.');
    }
    const onAppRenewCallData = new Uint8Array(0); // TODO: not supported in v0
    const toRenewAppCallData = appRegistryDapp.installer.interface.encodeFunctionData('renewApp', [
        appAddress,
        spaceAddress,
        onAppRenewCallData,
    ]);
    return smartAccount.sendUserOp({
        toAddress: [appRegistryDapp.installer.address],
        callData: [toRenewAppCallData],
        signer,
        value: [installPrice],
        spaceId: spaceAddress,
        functionHashForPaymasterProxy: 'renewApp',
    });
}
